export const textFieldBlueBg = {
  '& .MuiInput-root': { color: '#F6FEFC' },
  '& .MuiInputLabel-root.Mui-hover': { color: '#125D56' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#F6FEFC' },
  '& .MuiInput-input': { padding: '4px 16px', height: '2.2em' },
  '& .MuiInputLabel-root.Mui-error::after': { borderBottom: '2px solid #EF4444' },
  '& .MuiInput-root::after': { borderBottom: '2px solid rgb(0, 90, 112);' },
  '& .MuiInputLabel-root': { color: '#F6FEFC', padding: '0px 16px' },
  '& .MuiInput-root::before': { borderBottom: '1px solid rgba(226, 242, 246, 0.42)' },
  '& .MuiInput-root.MuiInput-underline:hover:before': { borderBottom: '2px solid rgb(46, 211, 183)' },
  '& input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 100px rgb(46, 211, 183) inset',
    WebkitTextFillColor: '#F6FEFC'
  }
}

export const textFieldWhiteBg = {
  '& .MuiInput-root': { color: 'rgb(46, 211, 183)' },
  '& .MuiInputLabel-root.Mui-hover': { color: '#107569' },
  '& .MuiInputLabel-root.Mui-error': { color: '#EF4444' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'rgb(46, 211, 183)' },
  '& .MuiInput-input': { padding: '4px 16px', height: '2.2em' },
  '& .MuiInputLabel-root.Mui-error::after': { borderBottom: '2px solid #EF4444' },
  '& .MuiInput-root::after': { borderBottom: '2px solid rgb(46, 211, 183)' },
  '& .MuiInputLabel-root': { color: 'rgb(46, 211, 183)', padding: '0px 16px' },
  '& .MuiInput-root::before': { borderBottom: '1px solid rgba(226, 242, 246, 0.42)' },
  '& .MuiInput-root.MuiInput-underline:hover:before': { borderBottom: '2px solid rgb(46, 211, 183)' },
  '& .MuiInputBase-input.MuiInput-input.Mui-disabled': { '-webkit-text-fill-color': '#00000095' }
}

export const textFieldDarkGreenBg = {
  '& .MuiInput-root': { color: 'rgb(0, 90, 112)' },
  '& .MuiInputLabel-root.Mui-hover': { color: '#107569' },
  '& .MuiInputLabel-root.Mui-error': { color: '#EF4444' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'rgb(0, 90, 112)' },
  '& .MuiInput-input': { padding: '4px 16px', height: '2.2em' },
  '& .MuiInputLabel-root.Mui-error::after': { borderBottom: '2px solid #EF4444' },
  '& .MuiInput-root::after': { borderBottom: '2px solid rgb(0, 90, 112)' },
  '& .MuiInputLabel-root': { color: 'rgb(0, 90, 112)', padding: '0px 16px' },
  '& .MuiInput-root::before': { borderBottom: '1px solid rgba(226, 242, 246, 0.42)' },
  '& .MuiInput-root.MuiInput-underline:hover:before': { borderBottom: '2px solid rgb(0, 90, 112)' },
  '& .MuiInputBase-input.MuiInput-input.Mui-disabled': { '-webkit-text-fill-color': '#00000095' }
}

export const baseButtonBlueBg = {
  '&.MuiButtonBase-root': {
    color: 'rgb(18, 93, 86)',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '12px 20px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#F6FEFC'
  },
  '&.MuiButtonBase-root:hover': {
    color: '#FFF',
    backgroundColor: 'rgb(18, 93, 86);'
  }
}

export const modalTabs = {
  '&.MuiTabs-root': {
    width: '100%'
  },
  '&.MuiTabs-root .Mui-selected': {
    color: 'rgb(46, 211, 183)'
  }
}

export const baseButtonWhiteBg = {
  '&.MuiButtonBase-root': {
    color: '#FFF',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '12px 20px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: 'rgb(46, 211, 183)'
  },
  '&.MuiButtonBase-root:hover': {
    color: '#107569',
    backgroundColor: '#F6FEFC'
  },
  '&.Mui-disabled': {
    opacity: 0.3
  }
}

export const baseButtonWarning = {
  '&.MuiButtonBase-root': {
    color: '#EF4444',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '12px 20px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#FEF2F2'
  },
  '&.MuiButtonBase-root:hover': {
    color: '#FFF',
    backgroundColor: '#EF4444'
  },
  '&.MuiButtonBase-root:hover .MuiButton-startIcon': {
    filter: 'brightness(0) invert(1)'
  },
  '&.Mui-disabled': {
    opacity: 0.3
  }
}

export const baseButtonSuccess = {
  '&.MuiButtonBase-root': {
    color: '#22C55E',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '12px 20px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#F0FDF4'
  },
  '&.MuiButtonBase-root:hover': {
    color: '#FFF',
    backgroundColor: '#22C55E'
  },
  '&.MuiButtonBase-root:hover .MuiButton-startIcon': {
    filter: 'brightness(0) invert(1)'
  },
  '&.Mui-disabled': {
    opacity: 0.3
  }
}

export const baseButtonCancel = {
  '&.MuiButtonBase-root': {
    color: '#F59E0B',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '12px 20px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#FFFBEB'
  },
  '&.MuiButtonBase-root:hover': {
    color: '#FFF',
    backgroundColor: '#F59E0B'
  },
  '&.MuiButtonBase-root:hover .MuiButton-startIcon': {
    filter: 'brightness(0) invert(1)'
  },
  '&.Mui-disabled': {
    opacity: 0.3
  }
}

export const baseButtonRedBg = {
  '&.MuiButtonBase-root': {
    color: '#FFF',
    fontSize: '16px',
    boxShadow: 'none',
    padding: '12px 20px',
    borderRadius: '12px',
    textTransform: 'none',
    backgroundColor: '#EF4444'
  },
  '&.MuiButtonBase-root:hover': {
    color: '#FFF',
    backgroundColor: '#000'
  },
  '&.Mui-disabled': {
    opacity: 0.3
  }
}

export const baseButtonTextWhiteBg = {
  '&.MuiButtonBase-root': {
    color: 'rgb(46, 211, 183)',
    fontSize: '16px',
    padding: '12px 20px',
    textTransform: 'none'
  }
}

export const checkApproveButton = {
  '&.MuiButtonBase-root': {
    color: '#107569',
    fontSize: '18px',
    textTransform: 'none',
    boxShadow: 'none'
  },
  '&.MuiButtonBase-root:hover': {
    background: 'none',
    opacity: '0.6'
  }
}

export const cancelDenyButton = {
  '&.MuiButtonBase-root': {
    color: '#EF4444',
    fontSize: '16px',
    textTransform: 'none',
    boxShadow: 'none'
  },
  '&.MuiButtonBase-root:hover': {
    background: 'none',
    opacity: '0.6'
  }
}

export const checkButton = {
  '&.MuiButtonBase-root': {
    color: '#107569',
    background: 'none',
    fontSize: '18px',
    boxShadow: 'none'
  }
}

export const cancelButton = {
  '&.MuiButtonBase-root': {
    color: '#EF4444',
    background: 'none',
    fontSize: '18px',
    boxShadow: 'none'
  }
}
